import axios from "@/app/Axios"

class Personal {

    async index() {
        try {
            const response = await axios.get("/personal")
            return response.data
        } catch (error) {
            console.log(error);
        }

    }
    async busquedaporci(id) {
        try {
            const response = await axios.get(`/personaci/${id}`)
            //console.log("Es mi response data de busqueda", response.data)
            if (response && response.data) {
                return {
                    status: true,
                    records: response.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }
        } catch (error) {
            console.log(error);
        }

    }
}

export default Personal